module.exports = function(){


    $(document).on('click', '[js-zoom-liner]', function(event) {
        event.preventDefault();

        var imgSrc = $(this).attr('js-zoom-liner');


        $.magnificPopup.open({
            items: {
                src: imgSrc,
            },
            mainClass: 'mfp-zoom-in  customize__liner-popup',
            type: 'image',
            removalDelay: 0,
            preloader: false,
            showCloseBtn: true,
            closeOnBgClick: false,
        });

    });

}; // end of module.exports



// WEBPACK FOOTER //
// ./js-source/integration/zoom-liner.js